
const formatNumber = (number="", minimumDigits=0, maximumDigits=8) => {
  if (number === null) {
    return ""
  }
  return Number(number).toLocaleString("en-CA", { minimumFractionDigits: minimumDigits, maximumFractionDigits: maximumDigits })
}
export default formatNumber
